import { createSelector } from 'reselect';

import { programLoanTypeOptions } from 'constants/options';

import { selectUnderwriting } from './underwriting.selectors';

export const selectProgramLoan = createSelector(selectUnderwriting, ({ programLoan }) =>
  programLoan.map(({ name }) => ({
    value: name,
    name: programLoanTypeOptions.find(({ value }) => value === name)?.name ?? name,
  })),
);
